import { IJudgmentCourt } from '../../../APIPackage/CatalogsModule/interfaces/IJudgmentCourt';
import { IKnmJudgmentCourtSelectOption } from '../interfaces/IKnmJudgmentCourtSelectOption';

export const createJudgmentCourtSelectOption = (erknmJudgmentCourt: IJudgmentCourt): IKnmJudgmentCourtSelectOption => ({
  ...erknmJudgmentCourt,
  label: erknmJudgmentCourt.title,
  value: erknmJudgmentCourt.guid,
  rfRegionCode: erknmJudgmentCourt.rfRegion,
  courtTypeCode: erknmJudgmentCourt.courtType,
  courtCode: erknmJudgmentCourt.code,
});
